<footer class="site-footer d-print-none">
    <div class="column text-center">
        <p class="text-xxs text-muted mb-0 mt-0">© All rights reserved. Made with
            <i class='material-icons favorite text-danger'></i> by 
            <a href="https://www.clouddimension.in" target="_blank" rel="noopener">CloudDimension Technology Pvt Ltd.</a>
        </p>
    </div>
    <div class="column text-right">
        <p class="text-muted text-xs mb-0 mt-0">Need Support? Call
            <span class="text-primary">&nbsp;+91 470 2622266 | +91 9947 388 133&nbsp;&nbsp;</span>
        </p>
    </div>
</footer>